import { generateVimeoIframe } from '../utils/methods';

const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, URLInputButton } =
  wp.blockEditor;
const { Button, PanelBody, IconButton, SelectControl, CheckboxControl } =
  wp.components;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { __ } = wp.i18n;

registerBlockType('pg/html-widgets', {
  title: 'PG Tiles Widgets',
  icon: 'welcome-widgets-menus',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    widgets: {
      type: 'array',
      default: [],
      source: 'query',
      selector: '.widget',
      query: {
        type: { type: 'string', source: 'attribute', attribute: 'data-type' },
        title: { type: 'string', source: 'text', selector: '.header-text' },
        description: {
          type: 'string',
          source: 'html',
          selector: 'div.description',
        },
        imgUrl: {
          type: 'string',
          source: 'attribute',
          attribute: 'src',
          selector: '.content .widget-photo--image',
        },
        imgAlt: {
          type: 'string',
          source: 'attribute',
          attribute: 'alt',
          selector: '.content .widget-photo--image',
        },
        logoUrl: {
          type: 'string',
          source: 'attribute',
          attribute: 'src',
          selector: '.content .widget-photo--logo',
        },
        logoAlt: {
          type: 'string',
          source: 'attribute',
          attribute: 'alt',
          selector: '.content .widget-photo--logo',
        },
        link: {
          type: 'string',
          source: 'attribute',
          attribute: 'href',
          selector: '.button-corner a, .widget[href]',
        },
      },
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    isSmall: {
      type: 'boolean',
      default: false,
    },
    fullItemLink: {
      type: 'boolean',
      default: false,
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      widgets,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      isSmall,
      fullItemLink,
    } = attributes;

    const clearLogo = (index) => {
      const newWidgets = widgets.map((widget, i) => {
        if (i === index) {
          return { ...widget, logoUrl: '', logoAlt: '' }; // Clear the logo URL and alt
        }
        return widget;
      });
      setAttributes({ widgets: newWidgets });
    };

    const addWidget = (type) => {
      const newWidget = {
        type,
        title: 'New Title',
        description: '<p>New Description...</p>',
        imgUrl: '',
        imgAlt: '',
        logoUrl: '',
        logoAlt: '',
        link: '#',
      };
      setAttributes({ widgets: [...widgets, newWidget] });
    };

    const updateWidget = (index, updates) => {
      const newWidgets = widgets.map((widget, i) =>
        i === index ? { ...widget, ...updates } : widget
      );
      setAttributes({ widgets: newWidgets });
    };

    const removeWidget = (index) => {
      const newWidgets = widgets.filter((_, i) => i !== index);
      setAttributes({ widgets: newWidgets });
    };

    const onImageSelect = (index, media, type = 'img') => {
      if (type === 'img') {
        updateWidget(index, { imgUrl: media.url, imgAlt: media.alt });
      } else {
        updateWidget(index, { logoUrl: media.url, logoAlt: media.alt });
      }
    };

    const getWidgetContent = (widget, index) => {
      if (widget.description && !widget.description.startsWith('<p>')) {
        widget.description = `<p>${widget.description}</p>`;
      }

      if (widget.type === 'widget-simple') {
        return (
          <div className={`widget ${widget.type}`}>
            <div className={'content'}>
              <RichText
                tagName={'strong'}
                className={'header-text'}
                value={widget.title}
                onChange={(title) => updateWidget(index, { title })}
              />
              <div className="description">
                <RichText
                  tagName={'p'}
                  className="description"
                  placeholder={__('Enter description here')}
                  value={widget.description ?? '<p>Example text...</p>'}
                  onChange={(description) =>
                    updateWidget(index, { description })
                  }
                />
              </div>
            </div>
            <div className="button-corner">
              <a
                href="#"
                className="btn btn-dark btn-outline btn-icon btn-small"
              >
                <URLInputButton
                  url={widget.link}
                  onChange={(newLink) => updateWidget(index, { link: newLink })}
                />
              </a>
            </div>
            <Button
              isSmall
              className="remove-widget-button"
              onClick={() => removeWidget(index)}
            >
              Remove Widget
            </Button>
          </div>
        );
      }

      if (widget.type === 'widget-photo') {
        return (
          <div className={`widget ${widget.type}`}>
            <div className={'content'}>
              <div>
                {widget.imgUrl && (
                  <img
                    className={'widget-photo--image'}
                    src={widget.imgUrl}
                    alt={widget.imgAlt || ''}
                  />
                )}
                <MediaUploadCheck>
                  <MediaUpload
                    onSelect={(media) => onImageSelect(index, media, 'img')}
                    allowedTypes={['image']}
                    value={widget.imgUrl}
                    render={({ open }) => (
                      <Button isSmall onClick={open} isSecondary>
                        Change Image
                      </Button>
                    )}
                  />
                </MediaUploadCheck>
              </div>
              <div>
                <RichText
                  tagName={'strong'}
                  className={'header-text'}
                  value={widget.title}
                  onChange={(title) => updateWidget(index, { title })}
                />
                <div className="description">
                  <RichText
                    tagName={'p'}
                    className="description"
                    placeholder={__('Enter description here')}
                    value={widget.description ?? '<p>Example text...</p>'}
                    onChange={(description) =>
                      updateWidget(index, { description })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="button-corner">
              <a
                href="#"
                className="btn btn-dark btn-outline btn-icon btn-small"
              >
                <URLInputButton
                  url={widget.link}
                  onChange={(newLink) => updateWidget(index, { link: newLink })}
                />
              </a>
            </div>
            <Button
              isSmall
              className="remove-widget-button"
              onClick={() => removeWidget(index)}
            >
              Remove Widget
            </Button>
          </div>
        );
      }

      if (widget.type === 'widget-photo-big') {
        return (
          <div className={`widget ${widget.type}`}>
            <div className="content">
              <div>
                <RichText
                  tagName={'strong'}
                  className={'header-text'}
                  value={widget.title}
                  onChange={(title) => updateWidget(index, { title })}
                />
                <div className="description">
                  <RichText
                    tagName={'p'}
                    className="description"
                    placeholder={__('Enter description here')}
                    value={widget.description ?? '<p>Example text...</p>'}
                    onChange={(description) =>
                      updateWidget(index, { description })
                    }
                  />
                </div>
                <div className="logo">
                  {widget.logoUrl && (
                    <img
                      className={'widget-photo--logo'}
                      src={widget.logoUrl}
                      alt={widget.logoAlt || ''}
                    />
                  )}
                  <MediaUploadCheck>
                    <MediaUpload
                      onSelect={(media) => onImageSelect(index, media, 'logo')}
                      allowedTypes={['image']}
                      value={widget.logoUrl}
                      render={({ open }) => (
                        <Button isSmall onClick={open} isSecondary>
                          Change Logo
                        </Button>
                      )}
                    />
                    {widget.logoUrl && (
                      <Button
                        isSmall
                        isDestructive
                        onClick={() => clearLogo(index)}
                      >
                        Remove Logo
                      </Button>
                    )}
                  </MediaUploadCheck>
                </div>
              </div>
              <div>
                <img
                  className={'widget-photo--image'}
                  src={widget.imgUrl}
                  alt={widget.imgAlt || ''}
                />
                <MediaUploadCheck>
                  <MediaUpload
                    onSelect={(media) => onImageSelect(index, media, 'img')}
                    allowedTypes={['image']}
                    value={widget.imgUrl}
                    render={({ open }) => (
                      <Button isSmall onClick={open} isSecondary>
                        Change Main Image
                      </Button>
                    )}
                  />
                </MediaUploadCheck>
              </div>
            </div>
            <div className="button-corner">
              <a
                href="#"
                className="btn btn-dark btn-outline btn-icon btn-small"
              >
                <URLInputButton
                  url={widget.link}
                  onChange={(newLink) => updateWidget(index, { link: newLink })}
                />
              </a>
            </div>
            <Button
              isSmall
              className="remove-widget-button"
              onClick={() => removeWidget(index)}
            >
              Remove Widget
            </Button>
          </div>
        );
      }

      return null;
    };

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <InspectorControls>
          <PanelBody title={__('Widget Settings')}>
            <Button isSecondary onClick={() => addWidget('widget-simple')}>
              + Add Simple Widget
            </Button>
            <Button isSecondary onClick={() => addWidget('widget-photo')}>
              + Add Photo Widget
            </Button>
            <Button isSecondary onClick={() => addWidget('widget-photo-big')}>
              + Add Big Photo Widget
            </Button>
          </PanelBody>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
              ]}
              onChange={(value) => setAttributes({ sectionClass: value })}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'None', value: 'corner-disabled' },
                { label: 'Left-Top', value: 'corner-left-top' },
                { label: 'Left-Bottom', value: 'corner-left-bottom' },
                { label: 'Right-Top', value: 'corner-right-top' },
                { label: 'Right-Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={(value) =>
                setAttributes({ cornerPositionClass: value })
              }
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'Light Secondary',
                  value: 'corner-on-light-secondary',
                },
                { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
              ]}
              onChange={(value) =>
                setAttributes({ cornerBackgroundClass: value })
              }
            />
            <CheckboxControl
              label={__('Is Small?')}
              checked={isSmall}
              onChange={(value) => setAttributes({ isSmall: value })}
            />
            <CheckboxControl
              label={__('Full Item as Link?')}
              checked={fullItemLink}
              onChange={(value) => setAttributes({ fullItemLink: value })}
            />
          </PanelBody>
        </InspectorControls>
        <div className={`widgets-grid ${isSmall ? 'widgets-grid-small' : ''}`}>
          {widgets.map((widget, index) => (
            <Fragment key={index}>{getWidgetContent(widget, index)}</Fragment>
          ))}
        </div>
      </section>
    );
  },
  save: ({ attributes }) => {
    const {
      widgets,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      isSmall,
      fullItemLink,
    } = attributes;

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <div className={`widgets-grid ${isSmall ? 'widgets-grid-small' : ''}`}>
          {widgets.map((widget, index) => {
            const WrapperTag = fullItemLink && widget.link ? 'a' : 'div';
            return (
              <WrapperTag
                key={index}
                className={`widget ${widget.type}`}
                data-type={widget.type}
                {...(WrapperTag === 'a' ? { href: widget.link } : {})}
              >
                {widget.type === 'widget-simple' && (
                  <>
                    <div className="content">
                      <strong className={'header-text'}>{widget.title}</strong>
                      <div
                        className="description"
                        dangerouslySetInnerHTML={{ __html: widget.description }}
                      ></div>
                    </div>
                    <p className="button-corner">
                      {WrapperTag === 'a' ? (
                        <span className="btn btn-dark btn-outline btn-icon btn-small"></span>
                      ) : (
                        <a
                          href={widget.link}
                          className="btn btn-dark btn-outline btn-icon btn-small"
                        ></a>
                      )}
                    </p>
                  </>
                )}

                {widget.type === 'widget-photo' && (
                  <>
                    <div className="content">
                      <div>
                        <img
                          className={'widget-photo--image'}
                          src={widget.imgUrl}
                          alt={widget.imgAlt || ''}
                        />
                      </div>
                      <div>
                        <strong className={'header-text'}>
                          {widget.title}
                        </strong>
                        <div
                          className="description"
                          dangerouslySetInnerHTML={{
                            __html: widget.description,
                          }}
                        ></div>
                      </div>
                    </div>
                    <p className="button-corner">
                      {WrapperTag === 'a' ? (
                        <span className="btn btn-dark btn-outline btn-icon btn-small"></span>
                      ) : (
                        <a
                          href={widget.link}
                          className="btn btn-dark btn-outline btn-icon btn-small"
                        ></a>
                      )}
                    </p>
                  </>
                )}

                {widget.type === 'widget-photo-big' && (
                  <>
                    <div className="content">
                      <div>
                        <strong className={'header-text'}>
                          {widget.title}
                        </strong>
                        <div
                          className="description"
                          dangerouslySetInnerHTML={{
                            __html: widget.description,
                          }}
                        ></div>
                        {widget.logoUrl && (
                          <div className="logo">
                            <img
                              className={'widget-photo--logo'}
                              src={widget.logoUrl}
                              alt={widget.logoAlt || ''}
                            />
                          </div>
                        )}
                      </div>
                      <div>
                        <img
                          className={'widget-photo--image'}
                          src={widget.imgUrl}
                          alt={widget.imgAlt || ''}
                        />
                      </div>
                    </div>
                    <p className="button-corner">
                      {WrapperTag === 'a' ? (
                        <span className="btn btn-dark btn-outline btn-icon btn-small"></span>
                      ) : (
                        <a
                          href={widget.link}
                          className="btn btn-dark btn-outline btn-icon btn-small"
                        ></a>
                      )}
                    </p>
                  </>
                )}
              </WrapperTag>
            );
          })}
        </div>
      </section>
    );
  },
});
